export const SET_JOURNEYS = 'JOURNEY/SET_JOURNEYS'
export const SET_JOURNEY = 'JOURNEY/SET_JOURNEY'
export const SET_NODES = 'JOURNEY/SET_NODES'
export const ADD_NODE = 'JOURNEY/ADD_NODE'
export const UPDATE_NODE = 'JOURNEY/UPDATE_NODE'
export const REMOVE_NODE = 'JOURNEY/REMOVE_NODE'
export const APPLY_SAVE_RESULT = 'JOURNEY/APPLY_SAVE_RESULT'
export const SET_SELECTED_NODE = 'JOURNEY/SET_SELECTED_NODE'
export const SET_DIRTY = 'JOURNEY/SET_DIRTY'
export const SET_LOADING = 'JOURNEY/SET_LOADING'
export const SET_SAVING = 'JOURNEY/SET_SAVING'
export const SET_REFERENCE_DATA = 'JOURNEY/SET_REFERENCE_DATA'
export const SET_ANALYTICS = 'JOURNEY/SET_ANALYTICS'
